import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { EMPTY, forkJoin, mergeMap, of } from 'rxjs';
import { TOAST_TYPE } from '../constants/app.constant';
import { BookingService } from '@services/booking.service';
import { ToastService } from '@services/toast.service';
import { TranslateService } from '@ngx-translate/core';

export const bookingDetailResolver: ResolveFn<[any] | null> = (
    route: ActivatedRouteSnapshot
) => {
    const bookingService = inject(BookingService);
    const toastService = inject(ToastService);
    const translateService = inject(TranslateService);
    const router = inject(Router);
    const code = route.queryParamMap.get('code');

    if (!code) {
        router.navigate(['booking', 'booking-manage']);
        return of(null);
    }

    return bookingService.getDetailBooking(code).pipe(
        mergeMap((detail) => {
            if (!detail.Data?.BookingCode) {
                toastService.add({
                    severity: TOAST_TYPE.ERROR,
                    summary: translateService.instant('common.tabs.error'),
                    detail: translateService.instant('pages.booking.toast.messages.bookingFailed'),
                });
                router.navigate(['booking', 'booking-manage']);
                return EMPTY;
            }

            return forkJoin([of(detail)]);
        })
    );
};
